import { render, staticRenderFns } from "./Translations.html?vue&type=template&id=414c0dab&scoped=true&"
import script from "./Translations.vue?vue&type=script&lang=js&"
export * from "./Translations.vue?vue&type=script&lang=js&"
import style0 from "./Translations.vue?vue&type=style&index=0&id=414c0dab&scoped=true&lang=css&"
import style1 from "./Translations.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414c0dab",
  null
  
)

export default component.exports